module.exports = "https://web-assets.ifttt.com/packs/media/pro_sla/sla_pro_bg-3fac0906.png";